import { useMemo } from 'react'
import Paper from '@mui/material/Paper'

import { FCWithChildren } from '@/types'

import { neutral } from '@/Theme/colors'

const Card: FCWithChildren<{
  error?: string | null
  success?: boolean
}> = ({ children, error, success }) => {
  let sx = useMemo(() => {
    let backgroundColor = neutral
    let borderColor = 'transparent'

    if (error) {
      backgroundColor = '#fffafa'
      borderColor = '#d32f'
    } else if (success) {
      backgroundColor = 'rgba(237, 247, 237, .5)'
      borderColor = '#2e7d32'
    }
    return {
      backgroundColor,
      border: error || success ? `1px solid ${borderColor}` : undefined
    }
  }, [error, success])

  return (
    <Paper
      elevation={3}
      sx={{
        px: 8,
        py: 6,
        flex: 1,
        minWidth: { xs: '80%', md: 500 },
        maxWidth: { xs: '80%', md: 500 },
        ...sx
      }}
    >
      {children}
    </Paper>
  )
}

export default Card
